/**** mgt.TicketView */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'TicketView',
  title: 'Виды билетов',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'ticket_kind_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'ticket_kind_name',
      title: 'Наименование',
      type: 'text',
      required: true
    }
  ],
  newTemplate: {
    ticket_kind_id: null,
    ticket_kind_name: ''
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'ticket_kind_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'ticket_kind_id',
        field: 'ticket_kind_id',
      },{
        title: 'ticket_kind_name',
        field: 'ticket_kind_name',
      }
    ],
    example: `1;Название`,
  },
  export: {
    fields: [
      {
        name: 'ticket_kind_name',
        title: 'Наименование',
      }
    ]
  }
};

export default config;